import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/training/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/console/$orgId/compliance/training/search', params, replace: true });
    },
});
